<template>
    <v-switch
        v-model="register"
        class="mt-0 pt-0 mr-2"
        color="orange"
        inset
        dense
        hide-details
        prepend-icon="mdi-basketball-hoop-outline"
        :label="register ? 'Registrations Open' : 'Registrations Closed'"
        @change="tongleRegister"
    />
</template>

<script>
    import registrationService from '@/services/registration'
    export default {
        data() {
            return {
                register: false
            }
        },
        created() {
            this.getRegisterStatus()
        },
        methods: {
            tongleRegister() {
                registrationService.registrationTongle().then((response) => {
                    this.register = response.data
                }).catch((error) => {
                    console.log(error)
                })
            },
            getRegisterStatus() {
                registrationService.getRegisterStatus().then((response) => {
                    this.register = response.data.registrations
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
    }
</script>
